import { jsx } from "react/jsx-runtime";
import { c } from "react/compiler-runtime";
import Card from "@effektify/components/Card";
import { styled } from "@effektify/theme";
import Skeleton from "@mui/material/Skeleton";
import CardTemplate from "./CardTemplates.js";
import { isTemplateCard } from "./guards.js";
const CardWrapperSkeleton = styled(Skeleton)(({
  theme
}) => ({
  borderRadius: theme.sizes.radius.xl,
  opacity: 0.5,
  display: "flex",
  flexDirection: "row",
  alignItems: "flex-start",
  alignSelf: "stretch",
  flex: "1 0 0",
  height: "100%",
  width: "100%",
  ".grouped & ": {
    borderRadius: 0,
    padding: 0,
    boxShadow: "none"
  }
}));
const getColorSchemeFromClassName = (className) => className.split(" ").find((cls) => cls.startsWith("color-scheme-"))?.replace("color-scheme-", "") || "";
const CardRenderer = (t0) => {
  const $ = c(22);
  const {
    config,
    data,
    width: containerWidth,
    height,
    className,
    isLoading: t1
  } = t0;
  const isLoading = t1 === void 0 ? false : t1;
  if (isTemplateCard(config)) {
    let t22;
    if ($[0] !== className) {
      t22 = getColorSchemeFromClassName(className || "") || "sand";
      $[0] = className;
      $[1] = t22;
    } else {
      t22 = $[1];
    }
    const containerColorScheme = t22;
    let t32;
    if ($[2] !== className) {
      t32 = [className];
      $[2] = className;
      $[3] = t32;
    } else {
      t32 = $[3];
    }
    const t42 = t32.join(" ");
    const t5 = `card-component-${config.id}`;
    let t6;
    if ($[4] !== config || $[5] !== containerColorScheme || $[6] !== containerWidth || $[7] !== data || $[8] !== height || $[9] !== isLoading || $[10] !== t5) {
      t6 = /* @__PURE__ */ jsx(CardTemplate, { config, data, maxHeight: height, maxWidth: containerWidth, isLoading, colorScheme: containerColorScheme }, t5);
      $[4] = config;
      $[5] = containerColorScheme;
      $[6] = containerWidth;
      $[7] = data;
      $[8] = height;
      $[9] = isLoading;
      $[10] = t5;
      $[11] = t6;
    } else {
      t6 = $[11];
    }
    let t7;
    if ($[12] !== t42 || $[13] !== t6) {
      t7 = /* @__PURE__ */ jsx(Card, { className: t42, children: t6 });
      $[12] = t42;
      $[13] = t6;
      $[14] = t7;
    } else {
      t7 = $[14];
    }
    return t7;
  }
  const {
    components
  } = config;
  if (!components || components.length === 0) {
    console.warn("No components found ", {
      components,
      data
    });
    return null;
  }
  if (isLoading) {
    let t22;
    if ($[15] !== className) {
      t22 = /* @__PURE__ */ jsx(CardWrapperSkeleton, { className, variant: "rectangular" });
      $[15] = className;
      $[16] = t22;
    } else {
      t22 = $[16];
    }
    return t22;
  }
  let t2;
  if ($[17] !== className || $[18] !== config.variant) {
    t2 = [className, config.variant];
    $[17] = className;
    $[18] = config.variant;
    $[19] = t2;
  } else {
    t2 = $[19];
  }
  const t3 = t2.join(" ");
  let t4;
  if ($[20] !== t3) {
    t4 = /* @__PURE__ */ jsx(Card, { className: t3, children: null });
    $[20] = t3;
    $[21] = t4;
  } else {
    t4 = $[21];
  }
  return t4;
};
export {
  CardRenderer,
  CardRenderer as default
};
